export const ANALYTICS_APPT_PREVIOUS_MONTH = 'amend appt:Previous month';
export const ANALYTICS_APPT_NEXT_MONTH = 'amend appt:Next month';
